import { Link } from 'react-router-dom';

export function CTASection() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="relative rounded-lg overflow-hidden">
        <div className="aspect-[21/9] bg-background-200 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20atmosphere%2C%20cozy%20reading%20nook%20with%20tablet%20showing%20comic%2C%20warm%20ambient%20lighting%2C%20comfortable%20and%20inviting%2C%20soft%20natural%20light%20from%20window%2C%20peaceful%20vibe%2C%20aesthetic%20composition&width=1400&height=600&seq=cta-banner&orientation=landscape"
            alt="妖精漫画网阅读体验"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/60 to-transparent flex items-center">
          <div className="px-6 md:px-12">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-2">
              妖精漫画网
            </h2>
            <p className="text-sm md:text-base text-background-50/80 mb-3 italic font-heading">
              最全的韩漫网
            </p>
            <p className="text-xs md:text-sm text-background-50/70 mb-6 max-w-md">
              每日更新海量韩国漫画，下拉式阅读体验，随时随地畅享免费漫画
            </p>
            <Link
              to="/category/romance"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}